/**
 * Brands grid handler
 * 
 * @description
 * <p>Handles Brands grid events on both Brands page and the Home page brands section.</p>
 * <p>On page load, adds 'click' and 'mouseleave' handlers for every .brands .thumb or .brands-page .thumb element.</p>
 * <p>Self-initializes when you include this module</p>
 * 
 * @module brands
 * 
 * @example <caption>HTML Structure (Brands Page)</caption>
 * {@lang xml}
 * <div id="site-holder" class="brands-page">
 *   ...
 *   <button type="button" class="thumb hoverable" data-cat="broadcast">
 *     <!-- Brands thumb code goes here -->
 *   </button>
 *   ...
 * </div>
 * 
 * @example <caption>HTML Structure (Home Page)</caption>
 * {@lang xml}
 * <div class="brands scrolling scroll-to">
 *   ...
 *   <button type="button" class="thumb hoverable">
 *     <!-- Brands thumb code goes here -->
 *   </button>
 *   ...
 * </div>
 */
(/** @lends module:brands */ function(site, $, undefined){
	"use strict";
(function($){
	var trace = {push: function() {}},
		dom = {},
		selectors = {
			wrap : '.brands',
			container : '.thumbs',
			thumb : '.thumb'
		},
		classes = {
			active : 'active',
			inactive : 'inactive',
			sorted : 'sorted'
		},
		current = "",
		brandsData = [],
		resizeTimer = {};

	/**
	 * Brands initializer
	 * @private
	 */
	function init() {

		trace = site.utilities && site.utilities.trace ? site.utilities.trace : {push: function() {}};
		
		// cache DOM elements
		dom.brands = $('.brands');
		dom.brandsPage = $('.brands-page');
		dom.brandsThumbs = dom.brandsPage.find('.thumbs');
		dom.nav = $('.sort-nav');
		dom.sortBtn = $('.sort-btn');

		/// Based on length of type identifies if it's home page brands vs brand-page brands
		
		if(dom.brands.length > 0) {
			dom.brand = dom.brands.find('.thumb');	
		}

		if(dom.brandsPage.length > 0) {
			dom.brand = dom.brandsPage.find('.thumb');	
		}
		
		// set up listeners for each brand element
		if(dom.brand) {
			dom.brand.each(function(i,elm){
				brandsData.push({'obj':$(this), 'cat':$(this).attr('data-cat')});
				brandListener($(elm));
			});	
		} else {
			return;
		}

		
		if(window.dragScrollRegion){
			window.dragScrollRegion(dom.nav,'x');
		}

		dom.nav.append('<div class="indicator"></div>');
		dom.indicator = $('.indicator');

		dom.nav.append('<div class="indicator-hrz"></div>');
		dom.indicatorH = $('.indicator-hrz');


		// Add click events to all brand nav buttons for sorting

		dom.sortBtn.click(function(e){
			sort(e.target.getAttribute('data-cat'));	
		});

		sort("all");

		var queryString = site.queryString("cat");
		if(queryString != null && queryString != undefined) {
			setTimeout(function(){ sort(queryString); }, 2500);
		}

		trace.push('queryString = '+queryString)
		/// sort initial value
		window.addEventListener("resize", resize);
		
	}
	/*
		When user resizes the browser reset the grid layout
	 */
	function resize() {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function(){ sort('resize'); }, 500);
	}

	/**
	 * Register listeners for a given brand element
	 * @private
	 * @param  {object} $brand jQuery oblect containing the brand element
	 */
	function brandListener(obj){
		obj.on('click', function(){
			setBrandActive(obj);
		})
		.on('mouseleave', function(){
			setBrandInactive(obj);
		});
	}

	/**
	 * add active class to brand if not already set
	 * @private
	 * @param {object} $brand jQuery oblect containing the brand element
	 */
	function setBrandActive(obj){
		trace.push('setBrandActive '+obj.hasClass(classes.active))
		if(!obj.hasClass(classes.active)){

			if(!obj.hasClass(classes.inactive)) {
				obj.addClass(classes.active);
				obj.css({"z-index":"100","overflow":"visible"});
				// remove active state from other brands
				obj.siblings(selectors.thumb).removeClass(classes.active);
			} 

			var cat = obj.attr('data-cat');
			if(current != "all") sort(cat);


			
		} else if (obj.hasClass(classes.active)) {
			setBrandInactive(obj);
		}
	}

	/**
	 * remove active class from brand if set
	 * @private
	 * @param {object} obj jQuery oblect containing the brand element
	 */
	function setBrandInactive(obj){
		if(obj.hasClass(classes.active)){
			obj.removeClass(classes.active).trigger("blur");
			obj.css({"z-index":"1","overflow":"hidden"});
		}
	}
	/**
	 * sort brand tiles based on category
	 * @private
	 * @param {string} cat pulled from data-cat on brand tiles in html
	 */
	function sort(cat){
		//trace.push('sort cat = '+cat+' current = '+current);

		// if not brands page or home page do nothing
		
		if(dom.brandsPage.length == 0)  {
			return;
		}

		// if all is selected and user selects a brand tile do nothing
		
		if(current == "all" && cat == "all") {
			return;
		}

		// if same category as selected do nothing
		// 
		if(current == cat) {
			return;
		}

		// if browser resize reset cat to the current category

		if(cat == "resize") {
			cat = current;
		} else {
			scrollToTop();
		}

		var breakpoint = site.getBreakPoint();

		var btnCatT = 0;
		var btnCatL = 0;

		var scrollL = dom.nav.scrollLeft();

		/// loop through all brand sort nav buttons an establish active state and set btn position for indicator animation

		dom.sortBtn.each(function(){
			var btnCat = $(this).attr('data-cat');
			if(btnCat == current) {
				$(this).removeClass(classes.active).trigger("blur");
			}
			if(btnCat == cat) {
				btnCatT = $(this).position().top;
				btnCatL = $(this).position().left;
				$(this).addClass(classes.active);
			}
			
		});

		//trace.push('scrollL = '+scrollL);
		//trace.push('btnCatL = '+btnCatL);

		//trace.push('breakpoint = '+breakpoint);

		// if on desktop animate indicator vertically
		// else animate indicator horizontally
		if(breakpoint != "bp-large") {
			
			dom.nav.stop( true, true ).animate({
					scrollLeft: scrollL+btnCatL+"px"
				}, 500, function() {
			});
			btnCatL = btnCatL + scrollL;
			dom.indicatorH.stop( true, true ).animate({
					left: btnCatL+"px",
					top:"initial"
				}, 500, function() {
			});
		} else {
			dom.indicator.stop( true, true ).animate({
					top: btnCatT+"px",
					left:"initial"
				}, 500, function() {
			});
		}
		
		// new sort array to build grid. 
		
		var sort = [];

		/// establish size of grid pattern based on size of brand tiles
		
		var btnW = Math.floor(dom.brand.outerWidth(true));
		var btnH = Math.floor(dom.brand.outerHeight(true));

		///defines grid layout based on break point, mobile first

		var row = 2;
		if(breakpoint == "bp-medium") {
			row = 4;
		}
		if(breakpoint == "bp-large") {
			row = 5;
		}
		trace.push('btnW = '+btnW);

		// only sort if it's any category but all

		if(cat != "all") {
			brandsData.forEach(function(obj) {
				//trace.push(i);
				if(obj.cat == cat) {
					if(obj.obj.hasClass(classes.inactive)) {
						obj.obj.removeClass(classes.inactive).trigger("blur");
					}
					sort.push(obj);
				}
			});

			brandsData.forEach(function(obj) {
				if(obj.cat != cat) {
					obj.obj.addClass(classes.inactive);
					sort.push(obj);
				}
			});	
		} else {
			brandsData.forEach(function(obj) {
				if(obj.obj.hasClass(classes.inactive)) {
					obj.obj.removeClass(classes.inactive).trigger("blur");
				}
				sort.push(obj);
			});
		}

		var left = 0;
		var top = 0;
		var rowCount = 1;

		sort.forEach(function(obj,i) {
			obj.obj.stop( true, true ).animate({
					left: left,
					top: top
				}, 800, function() {
			});

			left = left + btnW;
			if(rowCount == row) {
				left = 0;
				rowCount = 0;
				top = top + btnH;
			}
			rowCount++;

		});

		dom.brandsThumbs.height(top+btnH);
		//set current category
		current = cat;
		//scrollToTop();
		
	}

	function scrollToTop() {
		$('html,body').animate({ 'scrollTop': 0 }, 500, function(){
			
		});
	}
	$(function(){
		init();
	});
	})(jQuery);
})(window.site=window.site || {}, jQuery);


